module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": [{
        name: 'Administrative Settings'
      }, {
        name: 'Data Import'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('h4', [_vm._v("Import File")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn green pull-right import-btn",
    attrs: {
      "to": {
        name: 'Imports'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Continue\n              ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('h4', [_vm._v("Import History")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn green pull-right import-btn",
    attrs: {
      "to": {
        name: 'Imports History'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Continue\n              ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Data Import")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97873116","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ImportsSelect.vue
// module id = 1726
// module chunks = 1